module.exports = __webpack_public_path__ + "static/sketch-1-4a835720a8cd7978bfc107ff941dee62.jpeg";